import { takeEvery } from "redux-saga/effects";
import { getAllCategoriesAction, getTopCategoriesAction } from "./slices";
import { getAllCategoriesWorker, getTopCategoriesWorker } from "./workers";

const categoryWatcher = [
  takeEvery(getAllCategoriesAction, getAllCategoriesWorker),
  takeEvery(getTopCategoriesAction, getTopCategoriesWorker),
];

export default categoryWatcher;
